/**
 * AiChatCliSelector — Segmented control for switching between Claude and Codex adapters.
 *
 * Only visible when 2+ adapters are available. Disabled during streaming.
 */

import { cn } from '../../../lib/utils';

type AdapterInfo = { name: string; displayName: string };

type AiChatCliSelectorProps = {
  adapters: AdapterInfo[];
  activeAdapter: string;
  isLoading: boolean;
  onSwitch: (targetName: string) => void;
};

export function AiChatCliSelector({ adapters, activeAdapter, isLoading, onSwitch }: AiChatCliSelectorProps) {
  if (adapters.length < 2) return null;

  return (
    <div
      className="flex items-center rounded-md bg-muted p-0.5 gap-0.5"
      data-testid="ai-chat-cli-selector"
    >
      {adapters.map((adapter) => {
        const isActive = adapter.name === activeAdapter;
        return (
          <button
            key={adapter.name}
            className={cn(
              'px-2 py-0.5 text-xs rounded-sm transition-colors cursor-pointer',
              isActive
                ? 'bg-background text-foreground shadow-sm font-medium'
                : 'text-muted-foreground hover:text-foreground',
              isLoading && 'opacity-50 cursor-not-allowed',
            )}
            disabled={isLoading}
            onClick={() => {
              if (!isActive && !isLoading) onSwitch(adapter.name);
            }}
            data-testid={`ai-chat-cli-segment-${adapter.name}`}
          >
            {adapter.displayName}
          </button>
        );
      })}
    </div>
  );
}
